var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBrowserFirefox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "74px",
    height: "74px",
    viewBox: "0 0 74 74",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_browser_firefox") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "80.0412775%",
    y1: "13.1806518%",
    x2: "8.32159375%",
    y2: "90.9200636%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F",
    offset: "5%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF980E",
    offset: "37%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3647",
    offset: "53%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E31587",
    offset: "70%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "102.792556%",
    cy: "0.304597932%",
    fx: "102.792556%",
    fy: "0.304597932%",
    r: "125.431688%",
    gradientTransform: "translate(1.027926,0.003046),scale(0.816002,1.000000),translate(-1.027926,-0.003046)",
    id: "radialGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD4F",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF980E",
    offset: "28%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3750",
    offset: "47%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB0878",
    offset: "78%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E50080",
    offset: "86%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "58.8984179%",
    cy: "40.2480675%",
    fx: "58.8984179%",
    fy: "40.2480675%",
    r: "128.571024%",
    gradientTransform: "translate(0.588984,0.402481),scale(0.816002,1.000000),translate(-0.588984,-0.402481)",
    id: "radialGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#960E18",
    offset: "30%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B11927",
    stopOpacity: 0.74,
    offset: "35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DB293D",
    stopOpacity: 0.34,
    offset: "43%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5334B",
    stopOpacity: 0.09,
    offset: "50%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3750",
    stopOpacity: 0,
    offset: "53%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "-14.4145161%",
    cy: "-2.77408112%",
    fx: "-14.4145161%",
    fy: "-2.77408112%",
    r: "139.924731%",
    gradientTransform: "translate(-0.144145,-0.027741),scale(1.000000,0.589354),translate(0.144145,0.027741)",
    id: "radialGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F",
    offset: "13%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF980E",
    offset: "53%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "9.25995929%",
    cy: "108.798727%",
    fx: "9.25995929%",
    fy: "108.798727%",
    r: "100.116313%",
    gradientTransform: "translate(0.092600,1.087987),scale(1.000000,0.911351),translate(-0.092600,-1.087987)",
    id: "radialGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A8EE6",
    offset: "35%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9059FF",
    offset: "67%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C139E6",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "13.5088689%",
    cy: "31.7889%",
    fx: "13.5088689%",
    fy: "31.7889%",
    r: "53.166909%",
    gradientTransform: "translate(0.135089,0.317889),scale(1.000000,0.911351),translate(-0.135089,-0.317889)",
    id: "radialGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9059FF",
    stopOpacity: 0,
    offset: "21%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6E008B",
    stopOpacity: 0.6,
    offset: "97%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "162.816543%",
    cy: "-82.5131996%",
    fx: "162.816543%",
    fy: "-82.5131996%",
    r: "290.307529%",
    gradientTransform: "translate(1.628165,-0.825132),scale(1.000000,0.995776),translate(-1.628165,0.825132)",
    id: "radialGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226",
    offset: "10%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7139",
    offset: "79%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "74.1603175%",
    cy: "-39.3620827%",
    fx: "74.1603175%",
    fy: "-39.3620827%",
    r: "214.394347%",
    gradientTransform: "translate(0.741603,-0.393621),scale(0.839917,1.000000),translate(-0.741603,0.393621)",
    id: "radialGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F",
    offset: "11%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF980E",
    offset: "46%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3647",
    offset: "72%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E31587",
    offset: "90%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "54.3670033%",
    cy: "-31.971374%",
    fx: "54.3670033%",
    fy: "-31.971374%",
    r: "346.548295%",
    gradientTransform: "translate(0.543670,-0.319714),scale(1.000000,0.473489),rotate(83.965431),translate(-0.543670,0.319714)",
    id: "radialGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF980E",
    offset: "30%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3647",
    offset: "57%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E31587",
    offset: "74%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "46.3353312%",
    cy: "-33.6540887%",
    fx: "46.3353312%",
    fy: "-33.6540887%",
    r: "242.917868%",
    gradientTransform: "translate(0.463353,-0.336541),scale(0.980934,1.000000),translate(-0.463353,0.336541)",
    id: "radialGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F",
    offset: "14%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF980E",
    offset: "48%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3647",
    offset: "66%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E31587",
    offset: "90%"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    cx: "167.388889%",
    cy: "-40.0564666%",
    fx: "167.388889%",
    fy: "-40.0564666%",
    r: "349.483055%",
    gradientTransform: "translate(1.673889,-0.400565),scale(0.895609,1.000000),translate(-1.673889,0.400565)",
    id: "radialGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F",
    offset: "9%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF980E",
    offset: "63%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "75.395561%",
    y1: "14.1773109%",
    x2: "17.6455416%",
    y2: "83.9434497%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F",
    stopOpacity: 0.8,
    offset: "17%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F",
    stopOpacity: 0,
    offset: "60%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_browser_firefox",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Fx-Copy",
    transform: "translate(1.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.171358,24.511358 C66.6274074,20.857037 63.5120988,16.8098765 61.0637037,15.5491358 C62.8069543,18.9271934 64.0180194,22.5542253 64.6540741,26.3019753 L64.6540741,26.3567901 C60.6525926,16.3804938 53.8646914,12.3516049 48.3192593,3.59037037 C48.0360494,3.14271605 47.7528395,2.67679012 47.4879012,2.2291358 C47.3508642,1.99160494 47.2138272,1.75407407 47.0950617,1.4982716 C46.8674466,1.05330456 46.6897409,0.584529134 46.5651852,0.100493827 C46.5660746,0.0563897574 46.5353224,0.0179494424 46.4920988,0.00913580247 L46.4007407,0.00913580247 C46.4007407,0.00913580247 46.4007407,0.00913580247 46.4007407,0.00913580247 L46.4007407,0 C37.5116049,5.20740741 34.5241975,14.845679 34.2135802,19.6693827 C30.6610959,19.9143814 27.2645386,21.2227085 24.465679,23.4241975 C24.1729606,23.1776181 23.8680503,22.9458862 23.5520988,22.7298765 C22.7575875,19.9071006 22.7323538,16.9232165 23.4790123,14.0874074 C20.2140473,15.6719229 17.3120429,17.9145222 14.9553086,20.674321 L14.9553086,20.674321 C13.5483951,18.8928395 13.6488889,13.0276543 13.7311111,11.8034568 C13.3125715,11.9677949 12.9141174,12.1792821 12.5434568,12.4338272 C11.307044,13.320003 10.1486685,14.3102766 9.08098765,15.3938272 C7.85761319,16.6255494 6.73631283,17.9546112 5.72814815,19.3679012 L5.72814815,19.3679012 C3.45157067,22.594079 1.83692862,26.2394439 0.977530864,30.0933333 L0.931851852,30.3308642 C0.803950617,31.0617284 0.685185185,31.8017284 0.584691358,32.5417284 C0.584691358,32.5417284 0.584691358,32.5874074 0.584691358,32.6148148 C0.274334888,34.227884 0.081973337,35.8614305 0.00852180059,37.5024691 L0.00852180059,37.6851852 C-0.0987046938,56.1574331 14.0114721,71.6091397 32.4175613,73.1748525 C50.8236504,74.7405653 67.3410019,61.8941874 70.3548148,43.6691358 C70.4187654,43.2123457 70.4644444,42.7555556 70.5192593,42.2987654 C71.2296387,36.2666244 70.4225963,30.1525716 68.171358,24.511358 Z M27.3617284,52.2293827 L27.8459259,52.4669136 L27.8459259,52.4669136 L27.3617284,52.2293827 Z",
    id: "shape-base",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.171358,24.511358 C66.6274074,20.857037 63.5120988,16.8098765 61.0637037,15.5491358 C62.8069543,18.9271934 64.0180194,22.5542253 64.6540741,26.3019753 L64.6540741,26.3659259 C67.3804939,34.1699871 66.9877402,42.7254714 63.5577778,50.2469136 C59.5014815,58.9533333 49.671358,67.8790123 34.3232099,67.4496296 C17.714321,66.9745679 3.07876543,54.6595062 0.347160494,38.4982716 C-0.155308642,35.9585185 0.347160494,34.6612346 0.59382716,32.5965432 C0.254594032,34.2047909 0.0649783322,35.8409909 0.0267934055,37.4841975 L0.0267934055,37.6669136 C-0.0804330888,56.1391615 14.0297437,71.5908681 32.4358329,73.1565809 C50.841922,74.7222937 67.3592735,61.8759158 70.3730864,43.6508642 C70.437037,43.1940741 70.482716,42.737284 70.5375309,42.2804938 C71.239035,36.2528383 70.4257566,30.1453997 68.171358,24.511358 L68.171358,24.511358 Z",
    id: "body-outer-ring",
    fill: "url(#radialGradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.171358,24.511358 C66.6274074,20.857037 63.5120988,16.8098765 61.0637037,15.5491358 C62.8069543,18.9271934 64.0180194,22.5542253 64.6540741,26.3019753 L64.6540741,26.3659259 C67.3804939,34.1699871 66.9877402,42.7254714 63.5577778,50.2469136 C59.5014815,58.9533333 49.671358,67.8790123 34.3232099,67.4496296 C17.714321,66.9745679 3.07876543,54.6595062 0.347160494,38.4982716 C-0.155308642,35.9585185 0.347160494,34.6612346 0.59382716,32.5965432 C0.254594032,34.2047909 0.0649783322,35.8409909 0.0267934055,37.4841975 L0.0267934055,37.6669136 C-0.0804330888,56.1391615 14.0297437,71.5908681 32.4358329,73.1565809 C50.841922,74.7222937 67.3592735,61.8759158 70.3730864,43.6508642 C70.437037,43.1940741 70.482716,42.737284 70.5375309,42.2804938 C71.239035,36.2528383 70.4257566,30.1453997 68.171358,24.511358 L68.171358,24.511358 Z",
    id: "body-outer-ring-shadow",
    fill: "url(#radialGradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9595062,28.677284 L51.1787654,28.8325926 C50.2900138,27.2564101 49.1827462,25.8138865 47.8898765,24.5479012 C36.8903704,13.5392593 45.0120988,0.685185185 46.3733333,0 L46.3733333,0 C37.4750617,5.20740741 34.4967901,14.845679 34.1861728,19.6693827 C34.597284,19.6693827 35.0083951,19.6054321 35.428642,19.6054321 C41.8620793,19.6098808 47.7954674,23.0756776 50.9595062,28.677284 Z",
    id: "tail-tip",
    fill: "url(#radialGradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4651852,30.8698765 C35.4103704,31.7834568 32.2950617,34.7891358 31.2079012,34.7891358 C21.1585185,34.7891358 19.5049383,40.882716 19.5049383,40.882716 C19.9525926,46.0079012 23.5246914,50.2377778 27.8459259,52.4669136 L28.4488889,52.7592593 C28.7960494,52.9054321 29.1432099,53.0516049 29.4903704,53.1795062 C30.958415,53.7119509 32.4983671,54.0199413 34.0582716,54.0930864 C51.6995062,54.9244444 55.1254321,32.9893827 42.3901235,26.6308642 C45.3932836,26.2378273 48.4351932,26.9771351 50.922963,28.7046914 C47.7565697,23.1066066 41.8236299,19.6445617 35.3920988,19.6419753 C34.9718519,19.6419753 34.5607407,19.6419753 34.1496296,19.7059259 C30.5971453,19.9509246 27.200588,21.2592517 24.4017284,23.4607407 C24.9407407,23.9175309 25.5528395,24.5296296 26.8318519,25.7903704 C29.2893827,28.1291358 35.4560494,30.5866667 35.4651852,30.8698765 Z",
    id: "globe-base",
    fill: "url(#radialGradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4651852,30.8698765 C35.4103704,31.7834568 32.2950617,34.7891358 31.2079012,34.7891358 C21.1585185,34.7891358 19.5049383,40.882716 19.5049383,40.882716 C19.9525926,46.0079012 23.5246914,50.2377778 27.8459259,52.4669136 L28.4488889,52.7592593 C28.7960494,52.9054321 29.1432099,53.0516049 29.4903704,53.1795062 C30.958415,53.7119509 32.4983671,54.0199413 34.0582716,54.0930864 C51.6995062,54.9244444 55.1254321,32.9893827 42.3901235,26.6308642 C45.3932836,26.2378273 48.4351932,26.9771351 50.922963,28.7046914 C47.7565697,23.1066066 41.8236299,19.6445617 35.3920988,19.6419753 C34.9718519,19.6419753 34.5607407,19.6419753 34.1496296,19.7059259 C30.5971453,19.9509246 27.200588,21.2592517 24.4017284,23.4607407 C24.9407407,23.9175309 25.5528395,24.5296296 26.8318519,25.7903704 C29.2893827,28.1291358 35.4560494,30.5866667 35.4651852,30.8698765 Z",
    id: "globe-shadow",
    fill: "url(#radialGradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.802963,22.2548148 C23.0587654,22.4101235 23.2962963,22.5745679 23.5338272,22.7390123 C22.7271929,19.915647 22.6956357,16.9271769 23.4424691,14.0874074 C20.174413,15.6669313 17.2714491,17.9102721 14.9187654,20.674321 C15.0923457,20.6651852 20.2266667,20.5738272 22.802963,22.2548148 Z",
    id: "ear",
    fill: "url(#radialGradient-7)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.319753086,38.5165432 C3.06049383,54.668642 17.6777778,66.9928395 34.3049383,67.4679012 C49.6804938,67.897284 59.5014815,58.9716049 63.5395062,50.2651852 C66.9773253,42.7396793 67.3733983,34.1766458 64.6449383,26.3659259 L64.6449383,26.3659259 C64.6449383,26.3659259 64.6449383,26.3659259 64.6449383,26.3659259 L64.6449383,26.4207407 C65.905679,34.642963 61.7306173,42.5728395 55.2167901,47.9446914 L55.2167901,47.9903704 C42.5180247,58.3412346 30.3582716,54.2301235 27.8916049,52.5582716 L27.38,52.3024691 C19.9617284,48.6938272 16.9012346,41.9424691 17.5590123,36.1595062 C13.9647212,36.2144182 10.6763524,34.1439638 9.17234568,30.8790123 C13.1232927,28.4552649 18.0496964,28.2580704 22.1817284,30.3582716 C26.3777262,32.2613136 31.151527,32.4482 35.4834568,30.8790123 C35.4834568,30.5958025 29.3076543,28.1382716 26.9049383,25.7720988 C25.6167901,24.511358 25.0138272,23.8992593 24.465679,23.4424691 C24.1729606,23.1958897 23.8680503,22.9641578 23.5520988,22.7481481 L22.8212346,22.2639506 C20.2449383,20.582963 15.1106173,20.674321 14.937037,20.6834568 L14.937037,20.6834568 C13.5392593,18.9019753 13.6306173,13.0367901 13.7128395,11.8125926 C13.2971969,11.9769792 12.9017747,12.1884841 12.534321,12.442963 C11.2942553,13.3244671 10.1354859,14.3150774 9.07185185,15.402963 C7.84960224,16.6299111 6.73120212,17.9561014 5.72814815,19.3679012 L5.72814815,19.3679012 C3.45157067,22.594079 1.83692862,26.2394439 0.977530864,30.0933333 C0.959259259,30.1481481 -0.274074074,35.6296296 0.319753086,38.5165432 Z",
    id: "body",
    fill: "url(#radialGradient-8)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.8898765,24.5479012 C49.1851111,25.8152044 50.2926014,27.2610946 51.1787654,28.8417284 C51.3664075,28.9778207 51.5463548,29.1242185 51.7177778,29.2802469 C59.7390123,36.6802469 55.5365432,47.1407407 55.2259259,47.8807407 C61.7397531,42.5088889 65.9148148,34.5607407 64.6540741,26.3659259 C60.6525926,16.3804938 53.8646914,12.3516049 48.3192593,3.59037037 C48.0360494,3.14271605 47.7528395,2.67679012 47.4879012,2.2291358 C47.3508642,1.99160494 47.2138272,1.75407407 47.0950617,1.4982716 C46.8674466,1.05330456 46.6897409,0.584529134 46.5651852,0.100493827 C46.5660746,0.0563897574 46.5353224,0.0179494424 46.4920988,0.00913580247 L46.4007407,0.00913580247 C46.4007407,0.00913580247 46.4007407,0.00913580247 46.4007407,0.00913580247 C45.0120988,0.685185185 36.8903704,13.5392593 47.8898765,24.5479012 Z",
    id: "tail-flame",
    fill: "url(#radialGradient-9)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.708642,29.2345679 C51.5350617,29.0792593 51.3614815,28.9330864 51.1787654,28.7960494 L50.9595062,28.6407407 C48.46783,26.9142016 45.4235029,26.1750975 42.4175309,26.5669136 C55.1528395,32.9619753 51.7360494,54.8879012 34.085679,54.0291358 C32.5257745,53.9559907 30.9858224,53.6480002 29.5177778,53.1155556 C29.1706173,52.9876543 28.8234568,52.8414815 28.4762963,52.6953086 L27.8824691,52.402963 L27.8824691,52.402963 C30.34,54.0839506 42.4997531,58.1859259 55.2076543,47.8350617 L55.2076543,47.7893827 C55.5365432,47.1316049 59.7390123,36.6711111 51.708642,29.2345679 Z",
    id: "tail-small",
    fill: "url(#radialGradient-10)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5049383,40.882716 C19.5049383,40.882716 21.1402469,34.7891358 31.2079012,34.7891358 C32.2950617,34.7891358 35.4103704,31.7560494 35.4651852,30.8698765 C31.1362865,32.4385321 26.3655078,32.2516357 22.1725926,30.3491358 C18.0373396,28.2490987 13.1083808,28.4462571 9.15407407,30.8698765 C10.6704244,34.1282181 13.9562527,36.1948217 17.5498765,36.1503704 C16.8920988,41.9424691 19.9525926,48.6846914 27.3617284,52.2293827 L27.8459259,52.4669136 C23.5246914,50.2469136 19.9525926,46.0079012 19.5049383,40.882716 Z",
    id: "cheek-tufts",
    fill: "url(#radialGradient-11)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.171358,24.511358 C66.6274074,20.857037 63.5120988,16.8098765 61.0637037,15.5491358 C62.8069543,18.9271934 64.0180194,22.5542253 64.6540741,26.3019753 L64.6540741,26.3567901 C60.6525926,16.3804938 53.8646914,12.3516049 48.3192593,3.59037037 C48.0360494,3.14271605 47.7528395,2.67679012 47.4879012,2.2291358 C47.3508642,1.99160494 47.2138272,1.75407407 47.0950617,1.4982716 C46.8674466,1.05330456 46.6897409,0.584529134 46.5651852,0.100493827 C46.5660746,0.0563897574 46.5353224,0.0179494424 46.4920988,0.00913580247 L46.4007407,0.00913580247 C46.4007407,0.00913580247 46.4007407,0.00913580247 46.4007407,0.00913580247 L46.4007407,0 C37.5116049,5.20740741 34.5241975,14.845679 34.2135802,19.6693827 C34.6246914,19.6693827 35.0358025,19.6054321 35.4560494,19.6054321 C41.8875805,19.6080185 47.8205203,23.0700634 50.9869136,28.6681481 C48.4991439,26.9405919 45.4572342,26.2012841 42.4540741,26.594321 C55.1893827,32.9893827 51.7725926,54.9153086 34.1222222,54.0565432 C32.5623177,53.9833981 31.0223656,53.6754077 29.554321,53.142963 C29.2071605,53.0150617 28.86,52.8688889 28.5128395,52.722716 L27.9098765,52.4303704 L27.9098765,52.4303704 L27.3982716,52.1745679 L27.8824691,52.4120988 C23.5612346,50.182963 19.9891358,45.9530864 19.5414815,40.8279012 C19.5414815,40.8279012 21.1767901,34.734321 31.2444444,34.734321 C32.3407407,34.734321 35.4469136,31.7012346 35.5108642,30.8150617 C35.5108642,30.5318519 29.3350617,28.074321 26.9323457,25.7081481 C25.6441975,24.4474074 25.0320988,23.8353086 24.4930864,23.3785185 C24.200368,23.131939 23.8954577,22.9002072 23.5795062,22.6841975 C22.7842608,19.878214 22.7495775,16.9112139 23.4790123,14.0874074 C20.2140473,15.6719229 17.3120429,17.9145222 14.9553086,20.674321 L14.9553086,20.674321 C13.5483951,18.8928395 13.6488889,13.0276543 13.7311111,11.8034568 C13.3125715,11.9677949 12.9141174,12.1792821 12.5434568,12.4338272 C11.307044,13.320003 10.1486685,14.3102766 9.08098765,15.3938272 C7.85761319,16.6255494 6.73631283,17.9546112 5.72814815,19.3679012 L5.72814815,19.3679012 C3.45157067,22.594079 1.83692862,26.2394439 0.977530864,30.0933333 L0.931851852,30.3308642 C0.867901235,30.6414815 0.566419753,32.2219753 0.520740741,32.56 L0.520740741,32.56 C0.246979583,34.1953898 0.0730773854,35.8459352 -0.000614001877,37.5024691 L-0.000614001877,37.6851852 C-0.107840496,56.1574331 14.0023363,71.6091397 32.4084254,73.1748525 C50.8145146,74.7405653 67.3318661,61.8941874 70.345679,43.6691358 C70.4096296,43.2123457 70.4553086,42.7555556 70.5101235,42.2987654 C71.2233974,36.2673856 70.4194986,30.1533583 68.171358,24.511358 L68.171358,24.511358 Z",
    id: "overlay-yellow",
    fill: "url(#linearGradient-12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBrowserFirefox);
export default __webpack_public_path__ + "static/media/icon_browser_firefox.790853936609c47f1a5ef6a012725a63.svg";
export { ForwardRef as ReactComponent };